import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { UserPaymentMethodEnum } from '@/generated/api';

@Component({
    components: AllComponents(),
})
export default class Plan extends Mixins(CommonView) {

    public userPlanList: SBAPI.UserPlan[] = [];
    public error: string = "";
    public paymentMethodOK: boolean = false;
    public paymentMethod: UserPaymentMethodEnum | null = null;

    public async created() {
        if (await this.isLoginRedirect(true)) return;
        this.getUserPlanList();

        let userRes = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(userRes)) {
            this.error = "" + userRes.data;
            return;
        }

        if (userRes.data.paymentMethod) {
            this.paymentMethodOK = true;
            this.paymentMethod = userRes.data.paymentMethod;
        }
    }

    public async getUserPlanList() {
        let response = await SBAPI.UserPlanController.getUserPlanUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
            return
        };
        this.userPlanList = response.data;
    }

    public async update(index: number, userPlan: SBAPI.UserPlan) {
        this.userPlanList[index] = userPlan;
        let response = await SBAPI.UserPlanController.putUserPlanUsingPUT(this.userPlanList[index]).catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
            return
        }
        this.getUserPlanList();
    }

}
